import {
  buildOfflineAuditEvent,
  normalizeOfflineAuditEvents
} from '@/api/offlineAudit'

export const state = () => ({
  events: []
})

export const mutations = {
  HYDRATE_EVENTS (state, events) {
    state.events = normalizeOfflineAuditEvents(events)
  },
  ADD_EVENT (state, event) {
    state.events = normalizeOfflineAuditEvents([event, ...state.events])
  },
  CLEAR_EVENTS (state) {
    state.events = []
  }
}

export const actions = {
  hydrate ({ commit }, events = []) {
    commit('HYDRATE_EVENTS', events)
  },
  record ({ commit, rootState }, payload = {}) {
    const event = buildOfflineAuditEvent(payload, {
      authUser: rootState.auth?.user?.data,
      system: rootState.system,
      route: this.$router?.currentRoute,
      online: typeof navigator !== 'undefined' ? navigator.onLine : true
    })
    commit('ADD_EVENT', event)
    return event
  },
  clear ({ commit }) {
    commit('CLEAR_EVENTS')
  }
}

export const getters = {
  events (state) {
    return state.events
  }
}
